import { Tooltip } from "antd";
import TranslateText from "../components/common/TranslateText";

export const valueSelectCategorieNews = [
  {
    value: 5,
    label: "Tin tức",
  },
  {
    value: 4,
    label: "Tin tức an ninh",
  },
  {
    value: 1,
    label: "Thông báo",
  },
  { value: 2, label: "Khuyến cáo" },
  {
    value: 3,
    label: "Cảnh báo",
  },
];
export const valueSelectLicense = [
  {
    value: 2,
    label: "Post and Product Admin",
  },
  { value: 3, label: "Post Admin" },
  {
    value: 4,
    label: "Product Admin",
  },
  { value: 1, label: "Supper Admin" },
];
export const valueSelectStatusUser = [
  { value: 2, label: <TranslateText text={"Tất cả"} /> },
  {
    value: 0,
    label: (
      <Tooltip title="Không kích hoạt">
        <TranslateText text={"Không kích hoạt"} />
      </Tooltip>
    ),
  },
  { value: 1, label: <TranslateText text={"Đang kích hoạt"} /> },
];
export const valueSelectStatusDeals = [
  { value: 0, label: <TranslateText text={"Tất cả"} /> },
  { value: 1, label: <TranslateText text={"Chưa diễn ra"} /> },
  { value: 2, label: <TranslateText text={"Đang diễn ra"} /> },
  { value: 3, label: <TranslateText text={"Kết thúc"} /> },
];
export const valueSelectStatusProduct = [
  { value: 2, label: <TranslateText text={"Tất cả"} /> },
  { value: 1, label: <TranslateText text={"Còn hàng"} /> },
  { value: 0, label: <TranslateText text={"Hết hàng"} /> },
];

export const valueSelectTypeLimit = [
  { value: 0, label: <TranslateText text="Toàn bộ KH" /> },
  { value: 1, label: <TranslateText text="Nhóm" /> },
];
export const valueSelectTimeGroupStart = [
  { value: 0, label: "Ngày kích hoạt" },
  { value: 365, label: "1 năm" },
  { value: 2 * 365, label: `2 năm` },
  { value: 3 * 365, label: `3 năm` },
  { value: 4 * 365, label: `4 năm` },
  { value: 5 * 365, label: `5 năm` },
];
export const valueSelectTimeGroupEnd = [
  { value: 364, label: "1 năm" },
  { value: 365 * 2 - 1, label: `2 năm` },
  { value: 365 * 3 - 1, label: `3 năm` },
  { value: 365 * 4 - 1, label: `4 năm` },
  { value: 365 * 5 - 1, label: `5 năm` },
  { value: 365 * 10 - 1, label: `10 năm` },
];
export const selectRouterAdmin = [
  {
    value: "dang-tin-bai",
    label: "Trang chủ",
  },
  {
    value: "statistics",
    label: "Thống kê",
  },
  {
    value: "deals-statistics",
    label: "Thống kê ưu đãi",
  },
  {
    value: "news-statistics",
    label: "Thống kê tin tức an ninh",
  },
  {
    value: "banner-statistics",
    label: "Thống kê tương tác với banner",
  },
  {
    value: "product-statistics",
    label: "Thống kê tương tác với sản phẩm",
  },
  {
    value: "survey_statistics",
    label: "Thống kê cuộc khảo sát",
  },
  {
    value: "news",
    label: "Trang tin tức",
  },
  {
    value: "deals",
    label: "Trang ưu đãi",
  },
  {
    value: "storemanager",
    label: "Quản lý cửa hàng",
  },
  {
    value: "createaccount",
    label: "Quản lý tài khoản",
  },
  {
    value: "menuconfig",
    label: "Cấu hình menu",
  },
  {
    value: "admanager",
    label: "Quản lý banner",
  },
  {
    value: "surveyManager",
    label: "Quản lý khảo sát",
  },
  {
    value: "spam-management",
    label: "Quản lý danh sách data spam ",
  },
  {
    value: "logout",
    label: "Đăng xuất",
  },
];
export const selectRouterClient = [
  {
    value: "root",
    label: "Trang chủ",
  },

  {
    value: "tin-tuc?type=an-ninh",
    label: "Trang tin tức",
  },
  {
    value: "tin-tuc?type=uu-dai",
    label: "Trang ưu đãi",
  },
  {
    value: "cua-hang-bkav",
    label: "Quản lý cửa hàng",
  },
  {
    value: "copyright",
    label: "Bản quyền",
  },
  {
    value: "thong-ke",
    label: "Thống kê mã độc",
  },
  {
    value: "chat",
    label: "Hội thoại trực tuyến",
  },
];
export const timeSelectSort = [
  { value: -1, label: "Tất cả" },
  {
    value: 5,
    label: "Hôm nay",
  },
  {
    value: 6,
    label: "Hôm qua",
  },
  {
    value: 7,
    label: "7 ngày qua",
  },
  {
    value: 1,
    label: "1 tháng trước",
  },
  { value: 2, label: "3 tháng trước" },
  {
    value: 3,
    label: "6 tháng trước",
  },
  { value: 4, label: "1 năm trước" },
  {
    value: 0,
    label: "Khoảng thời gian",
  },
];
export const timeSelectStatistic = [
  { value: -1, label: "Tất cả" },
  {
    value: 5,
    label: "Hôm nay",
  },
  {
    value: 6,
    label: "Hôm qua",
  },
  {
    value: 7,
    label: "7 ngày qua",
  },
  {
    value: 1,
    label: "1 tháng trước",
  },
  { value: 2, label: "3 tháng trước" },
  {
    value: 3,
    label: "6 tháng trước",
  },
  { value: 4, label: "1 năm trước" },
  {
    value: 0,
    label: "Khoảng thời gian",
  },
];

export const timeSelectReport = [
  { value: 1, label: "7 ngày" },
  { value: 2, label: "14 ngày" },
  { value: 3, label: "21 ngày" },
  { value: 4, label: "28 ngày" },
];
